<template>
  <donut-chart06-template
    :data-type="dataType"
    :size="size"
    :reload-count="reloadCount"
    :orientation="orientation"
    unit="건"
    :board-ids="[107]"
    title="(시설물)안전·보건 교육 현황"
    field-code="facility"
    :graph-id="77"
  />
</template>

<script>
/* eslint-disable brace-style */
import DonutChart06Template from "@/views/graph/DonutChart06Template.vue";

export default {
  name: 'DonutChart77',
  components: {DonutChart06Template},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
    size: String,
    reloadCount: Number,
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
  },
}
</script>

<style scoped>

</style>
